import React, { useCallback, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

import { SHeadTableCell } from '../../../../components/styledComponents/Tables';
import AlertDialog from '../../../../components/other/Dialog/AlertDialog';
import Preloader from '../../../../components/other/Preloader/Preloader';
import { IAppState } from '../../../../store/rootDuck';
import { actions as orderActions } from '../../../../store/ducks/orders.duck';
import {
  getOrderTypeWithTranslates,
  ListType,
  getStatusTypeWithTranslates,
} from '../constatns';
import { actions as profileActions } from '../../../../store/ducks/profile.duck';
import { actions as companiesActions } from '../../../../store/ducks/companies.duck';

import { useStyles } from '../hooks/useStyles';
import { useDefineUserRole, useFormatMessage } from '../../../../hooks';
import TableRowOrderList from './TableRowOrderList';
import { getStatusString } from '../../../../utils/utils';
import TablePaginator from '../../../../components/TablePaginator/TablePaginator';

const OrdersList: React.FC<
  TPropsFromRedux & { type: string; userId?: number; smallSendMsgBtn?: boolean }
> = ({
  orders,
  loading,
  fetch,
  page,
  perPage,
  total,
  delOrder,
  delError,
  clearErrors,
  editStatus,
  meLoading,
  fetchMe,
  clearMe,
  me,
  type,
  userId,
}) => {
  const classes1 = useStyles();
  const { classes } = classes1;
  const intl = useIntl();
  const fm = useFormatMessage();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [deleteId, setDeleteId] = useState<number | undefined>(-1);
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(-1);
  const [selectedType, setSelectedType] = useState<string>('');
  const [selectedPaidId, setSelectedPaidId] = useState(-1);
  const defaultType = { value: '', label: fm('ORDER.FILTER.PLACEHOLDER') };
  const [paymentType, setPaymentType] = useState<string>('');
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);
  const isBuyer = useDefineUserRole(me, ['ROLE_BUYER', 'ROLE_BUYER_STAFF']);

  const selectedOrderStatuses: string[] = [];
  const selectedPaidOrderStatuses: string[] = [];

  useEffect(() => {
    const statuses = getStatusString(type, selectedOrderStatuses);
    fetch({
      statuses: selectedType || statuses,
      page: 1,
      perPage: 10,
      userId,
      payment_status: paymentType,
    });
  }, [type, userId, me, paymentType, selectedType]);

  const deleteAction = useCallback(() => {
    setAlertOpen(false);
    if (deleteId) {
      delOrder({
        page,
        perPage,
        id: deleteId,
        statuses: selectedType || getStatusString(type, selectedOrderStatuses),
      });
    }
  }, [deleteId, page, perPage, type, delOrder, me, selectedType]);

  const selectAction = useCallback(
    (id: number) => {
      setSelectedId(id);
    },
    [setSelectedId]
  );
  useEffect(() => {
    if (delError) {
      enqueueSnackbar(delError, { variant: 'error' });
      setAlertOpen(false);
      clearErrors();
    }
    return () => {
      clearErrors();
    };
  }, [delError, clearErrors, setAlertOpen, enqueueSnackbar]);

  useEffect(() => {
    if (!me) fetchMe();
    return () => {
      clearMe();
    };
  }, []);

  const translates: { [type: string]: string } = {
    cart: intl.formatMessage({ id: 'ORDER.TYPE.CART' }),
    new: intl.formatMessage({ id: 'ORDER.TYPE.NEW' }),
    formation: intl.formatMessage({ id: 'ORDER.TYPE.FORMATION' }),
    ready_to_delivery: intl.formatMessage({ id: 'ORDER.TYPE.DELIVERY' }),
    payed: intl.formatMessage({ id: 'ORDER.TYPE.PAYED' }),
    canceled: intl.formatMessage({ id: 'ORDER.TYPE.CANCELED' }),
    completed: intl.formatMessage({ id: 'ORDER.TYPE.COMPLETED' }),
    in_processing: intl.formatMessage({ id: 'ORDER.TYPE.PROCCESS' }),
  };
  const translatesPayment: { [type: string]: string } = {
    paid: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.PAID' }),
    not_paid: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.NOT_PAID' }),
    partially_paid: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.PARTIALLY_PAID' }),
  };
  const PaymentOrderStates = [
    { lable: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.PAID' }), value: 'paid' },
    { lable: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.NOT_PAID' }), value: 'not_paid' },
    {
      lable: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.PARTIALLY_PAID' }),
      value: 'partially_paid',
    },
  ];
  const selectStyles = {
    container: (provided: any) => ({
      ...provided,
      marginBottom: 16,
      width: '100%',
    }),
    menu: (provided: any, state: any) => ({
      ...provided,
      zIndex: 999,
      display: state.selectProps.isSearchable ? provided.display : 'none',
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderColor: state.isFocused ? '#205373' : '',
      backgroundColor: '#f5f8fa',
      border: 'none !important',
      opacity: state.isDisabled ? 0.5 : 1,
      boxShadow: state.isFocused ? '0 0 0 1px #205373 !important' : '',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#205373' : '#fff',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: '#181c32',
      fontWeight: 400,
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontWeight: 400,
    }),
    dropdownIndicator: (provided: any, state: any) => {
      return {
        ...provided,
        display: state.selectProps.isSearchable ? provided.display : 'none',
      };
    },
  };
  const orderTypes = getOrderTypeWithTranslates(translates);
  const orderStatusTypes = getStatusTypeWithTranslates(translatesPayment);

  useEffect(() => {
    const statuses = getStatusString(type, selectedOrderStatuses);
    fetch({ statuses: selectedType || statuses, page: 1, perPage: 10, userId });
  }, [type]);

  const selectActionPaid = useCallback(
    (id: number) => {
      setSelectedPaidId(id);
    },
    [setSelectedPaidId]
  );

  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem('catalogScrollPosition', window.scrollY?.toString());
    };
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const savedScroll = sessionStorage.getItem('catalogScrollPosition');
    if (savedScroll) {
      window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'auto' });
    }
  }, []);

  const handleDeleteDialog = useCallback((id: number | undefined) => {
    setDeleteId(id);
    setAlertOpen(true);
  }, []);

  const editAction = useCallback(
    (item: any, mode: string) => {
      navigate(`/orders/${item.id}/${mode}`);
    },
    [navigate]
  );

  if (meLoading) return <Preloader />;

  return (
    <>
      <div className={classes.container}>
        {type === ListType.FULL && (
          <div className={classes.filterCol}>
            <Card className={classes.filter}>
              <Typography className={classes.title}>
                {intl.formatMessage({
                  id: 'ORDER.LIST',
                })}
              </Typography>
              <div className={classes.selects}>
                <div className={classes.containerSelect}>
                  <Typography className={classes.label}>
                    {intl.formatMessage({
                      id: 'ORDER.FILTER.TYPE',
                    })}
                  </Typography>
                  <Select
                    placeholder={fm('ORDER.FILTER.PLACEHOLDER')}
                    components={{ IndicatorSeparator: () => null }}
                    value={
                      selectedType
                        ? { label: translates[selectedType], value: selectedType }
                        : undefined
                    }
                    styles={selectStyles}
                    onChange={item => {
                      if (item) {
                        setSelectedType(item.value);
                      }
                    }}
                    options={
                      orderTypes
                        ? [
                            defaultType,
                            ...orderTypes.map(item => ({
                              label: item.translate,
                              value: item.type,
                            })),
                          ]
                        : [defaultType]
                    }
                  />
                </div>
                <div className={classes.containerSelect}>
                  <Typography className={classes.label}>
                    {intl.formatMessage({
                      id: 'ORDER.PAYMENT.STATUS',
                    })}
                  </Typography>
                  <Select
                    placeholder={fm('ORDER.FILTER.PLACEHOLDER')}
                    components={{ IndicatorSeparator: () => null }}
                    value={
                      paymentType
                        ? { label: translatesPayment[paymentType], value: paymentType }
                        : undefined
                    }
                    styles={selectStyles}
                    onChange={item => {
                      if (item) {
                        setPaymentType(item.value);
                      }
                    }}
                    options={
                      orderTypes
                        ? [
                            defaultType,
                            ...PaymentOrderStates.map(item => ({
                              label: item.lable,
                              value: item.value,
                            })),
                          ]
                        : [defaultType]
                    }
                  />
                </div>
              </div>
            </Card>
          </div>
        )}
        <div className={`${classes.ordersCol} ${type === ListType.ABANDONED ? 'full' : ''}`}>
          {loading ? (
            <Preloader />
          ) : (
            <>
              {!orders || !orders.length ? (
                <Typography className={classes.empty} component='h5' variant='h5'>
                  {intl.formatMessage({ id: 'ORDER.CATALOG.LIST.EMPTY' })}
                </Typography>
              ) : (
                <div>
                  <Card className={classes.card}>
                    <CardContent className={classes.tableContainer}>
                      <Table aria-label='purchases'>
                        <TableHead>
                          <TableRow>
                            <SHeadTableCell className={classes.cell} align='left'>
                              {intl.formatMessage({ id: 'ORDER.TABLE.ID' })}
                            </SHeadTableCell>
                            <SHeadTableCell className={classes.cell} align='left'>
                              {intl.formatMessage({ id: 'ORDER.DATE' })}
                            </SHeadTableCell>
                            {isBuyer && (
                              <SHeadTableCell className={classes.cell} align='left'>
                                {intl.formatMessage({
                                  id: 'STATISTIC.ORDER.TABLE.QUANTITY.GOODS',
                                })}
                              </SHeadTableCell>
                            )}
                            {me?.is_admin && (
                              <>
                                <SHeadTableCell className={classes.cell} align='left'>
                                  {intl.formatMessage({ id: 'USER.ROLES.BUYER' })}
                                </SHeadTableCell>
                              </>
                            )}
                            {!isVendor && (
                              <SHeadTableCell className={classes.cell} align='right'>
                                {intl.formatMessage({
                                  id: isBuyer ? 'ORDER.TABLE.SUM_PAY' : 'BUYER.BILL',
                                })}
                              </SHeadTableCell>
                            )}
                            <SHeadTableCell className={classes.cell} align='left'>
                              {intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS' })}
                            </SHeadTableCell>
                            {isVendor && (
                              <SHeadTableCell className={classes.cell} align='right'>
                                {intl.formatMessage({ id: 'PROVIDER.ORDER.BILL' })}
                              </SHeadTableCell>
                            )}
                            {/* {!isVendor && !isBuyer && (
                              <SHeadTableCell className={classes.cell}>
                                {intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS' })}
                              </SHeadTableCell>
                            )} */}
                            <SHeadTableCell className={classes.cell} align='left'>
                              {intl.formatMessage({ id: 'ORDER.TABLE.STATUS' })}
                            </SHeadTableCell>
                            <SHeadTableCell className={classes.cell} />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orders.map(item => (
                            <TableRowOrderList
                              key={item.id?.toString()}
                              item={item}
                              me={me}
                              type={type}
                              selectAction={selectAction}
                              selectActionPaid={selectActionPaid}
                              handleDeleteDialog={handleDeleteDialog}
                              editAction={editAction}
                              selectedOrderStatuses={selectedOrderStatuses}
                              selectedPaidOrderStatuses={selectedPaidOrderStatuses}
                              selectedId={selectedId}
                              selectedPaidId={selectedPaidId}
                              isBuyer={!!isBuyer}
                              translates={translates}
                              translatesStatus={translatesPayment}
                              editStatus={editStatus}
                              page={page}
                              perPage={perPage}
                              userId={userId}
                              orderTypes={orderTypes}
                              orderStatusTypes={orderStatusTypes}
                            />
                          ))}
                        </TableBody>
                      </Table>
                      <div className={classes.containerPagination}>
                        <TablePaginator
                          id={+''}
                          page={page || 1}
                          realPerPage={orders.length}
                          perPage={perPage || 10}
                          total={total || 0}
                          fetchRows={(props: any) =>
                            fetch({
                              page: props.page,
                              perPage: props.perPage,
                              statuses:
                                selectedType || getStatusString(type, selectedOrderStatuses),
                            })
                          }
                          rowsPerPageOptions={[10, 50, 100]}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <AlertDialog
        open={isAlertOpen}
        message={intl.formatMessage({ id: 'ORDER.DELETE.TEXT' })}
        okText={intl.formatMessage({ id: 'CATEGORIES.DELETE.OK' })}
        cancelText={intl.formatMessage({ id: 'CATEGORIES.DELETE.CANCEL' })}
        handleClose={() => {
          clearErrors();
          setAlertOpen(false);
        }}
        handleAgree={() => deleteAction()}
      />
    </>
  );
};

const connector = connect(
  (state: IAppState) => ({
    meLoading: state.profile.loading,
    orders: state.orders.orders,
    loading: state.orders.loading,
    page: state.orders.page,
    perPage: state.orders.per_page,
    total: state.orders.total,
    delError: state.orders.delError,
    userRole: state.auth.user?.roles,
    me: state.profile.me,

    companies: state.companies.companies,
    loadingCompanies: state.companies.loading,
  }),
  {
    fetch: orderActions.fetchRequest,
    delOrder: orderActions.delRequest,
    clearErrors: orderActions.clearEdit,
    editStatus: orderActions.editStatusRequest,

    fetchMe: profileActions.fetchRequest,
    clearMe: profileActions.clearMe,
    fetchCompanies: companiesActions.fetchRequest,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(OrdersList);
